import React from "react";
import { Link } from "react-router-dom";
import { useSiteContent } from "../i18n/SiteContent";
import { ArrowRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function CmsImg({ imageId, alt = "" }) {
  const [src, setSrc] = React.useState(null);
  React.useEffect(() => {
    if (!imageId) return;
    let c = false;
    fetch(`${API}/images/${imageId}`).then((r) => r.json()).then((j) => !c && setSrc(j.data_url)).catch(() => {});
    return () => { c = true; };
  }, [imageId]);
  if (!src) return null;
  return <img src={src} alt={alt} className="w-full h-full object-cover" />;
}

export default function Brands() {
  const { pg } = useSiteContent();
  const [brands, setBrands] = React.useState([]);

  React.useEffect(() => {
    let c = false;
    fetch(`${API}/brands`).then((r) => r.json()).then((j) => !c && setBrands(Array.isArray(j) ? j : [])).catch(() => {});
    return () => { c = true; };
  }, []);

  const heading = pg("products.heading", "Brands we represent");
  const sub = pg("products.sub", "");

  return (
    <section id="products" data-testid="products-section" className="py-10 md:py-20 reveal" style={{ background: "#F5F7FA" }}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="max-w-4xl">
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl lg:text-[54px] leading-[1.05] anim anim-up"
            style={{ color: "#0F2A6E", letterSpacing: "-0.025em" }}>
            {heading}
          </h2>
          {sub && <p className="mt-6 text-[#6B7A8D] text-lg md:text-xl font-light leading-relaxed max-w-2xl">{sub}</p>}
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger anim">
          {brands.map((b, i) => (
            <Link
              key={b.id}
              to={`/products/${b.slug || b.id}`}
              data-testid={`brand-card-${i}`}
              className="anim anim-up card-lift group p-7 rounded-2xl border border-slate-200 bg-white hover:border-[#1B6FE0]/50 flex flex-col"
            >
              <div className="flex items-center gap-3">
                {b.logo_id ? (
                  <div className="w-11 h-11 rounded-lg overflow-hidden border border-slate-100 bg-white flex items-center justify-center">
                    <CmsImg imageId={b.logo_id} alt={b.name} />
                  </div>
                ) : (
                  <div className="w-11 h-11 rounded-lg flex items-center justify-center font-heading font-bold text-white" style={{ background: "#0F2A6E" }}>
                    {b.name?.[0] || "B"}
                  </div>
                )}
                <div className="font-heading font-semibold text-[18px] tracking-tight" style={{ color: "#0F2A6E", letterSpacing: "-0.01em" }}>{b.name}</div>
              </div>
              {b.tagline && <p className="mt-3 text-[13.5px] text-[#6B7A8D] leading-relaxed">{b.tagline}</p>}
              {b.description && <p className="mt-2 text-[12.5px] text-[#6B7A8D] leading-relaxed line-clamp-3">{b.description}</p>}
              <div className="mt-auto pt-4">
                <span className="inline-flex items-center gap-1.5 text-[12.5px] font-medium transition group-hover:gap-3" style={{ color: "#1B6FE0" }}>
                  Learn more <ArrowRight size={13} weight="bold" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
